import { fromJS } from 'immutable';
import { actionTypes } from './actions';
import initialState from './initialState';
import { createReducer } from 'utils/redux';

function mapGeoCoding(state, payload) {
  const data = state.get('data');
  const coordinateObject = fromJS({
    [payload.id]: payload.coordinates,
  });

  return data ? data.merge(coordinateObject) : coordinateObject;
}

const onStart = (state) => state.set('loading', true).set('error', null);
const onSuccess = (state, { payload }) =>
  state.set('data', mapGeoCoding(state, payload)).set('loading', false);
const onError = (state, { payload }) => state.set('loading', false).set('error', payload);

export default createReducer(initialState, {
  [actionTypes.REQUEST_START]: onStart,
  [actionTypes.REQUEST_SUCCESS]: onSuccess,
  [actionTypes.REQUEST_FAILURE]: onError,
});
